import Dynamic from "@/api/ClaimsNotifications/Dynamic";

class DynamicIpr extends Dynamic {
  static getResourceEndpoint() {
    return '/claims-dynamic-documents-ipr';
  }
}

export default DynamicIpr;
